import AOS from 'aos';

(function (Drupal) {
  Drupal.behaviors.animaciones = {
    attach() {
      AOS.init({ 
        disable: false,
        startEvent: "DOMContentLoaded",
        initClassName: "aos-init",
        animatedClassName: "aos-animate",
        useClassNames: false,
        disableMutationObserver: false,
        debounceDelay: 50,
        throttleDelay: 99,

        // Element-specific settings
        offset: 25, // distancia desde el trigger
        delay: 500, // retardo en ms
        duration: 600, // duración
        easing: "ease-out",
        once: true,
        mirror: false,
        anchorPlacement: "top-bottom", 
      });
    },
  };
})(Drupal);